import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1505.077 -4147)">
      <path
        d="M135.673.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4147)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M150.432,13.148a14.986,14.986,0,0,0-14.76-12.4v15L140.8,29.833a14.893,14.893,0,0,0,9.634-16.685"
        transform="translate(-1625 4147)"
        fill={color}
      />
    </g>
  </svg>
);
